// extracted by mini-css-extract-plugin
export default {"recentPosts":"twyBWD"};